module.exports = __webpack_public_path__ + "img/before-5.5e4d913c.png";